import { gql } from '@apollo/client';

export const ADYEN_SUBMIT_PAYMENT_DETAILS = gql`
  mutation AdyenSubmitPaymentDetails($input: AdyenSubmitDetailsInput!) {
    adyenSubmitPaymentDetails(input: $input) {
      resultCode
      action
      refusalReasonCategory
    }
  }
`;
